import React from 'react';
import LocalizedLink from '../../LocalizedLink';
import Image from '../../Image';
import { Sizes } from '../../../constants/Image';
import { Banner } from './SingleBanner2';

type Props = {
  banner: Banner;
};

export default function BannerDesign2({ banner }: Props) {
  return (
    <div className="flex flex-col lg:relative">
      <div className="relative">
        <Image
          className="bg-rgrey-lightlight object-cover h-95 md:h-145 xl:h-180 w-full object-[75%_center] lg:object-[60%_center] xl:object-center"
          image={banner.image}
          defaultSize={Sizes.W890}
          allSizes={[Sizes.W890, Sizes.W1600]}
          alt={banner.title || 'Rademar'}
        />
        {/* Gradient overlay for mobile and tablet screens, only over image */}
        <div className="absolute bottom-0 left-0 w-full h-1/2 bg-linear-to-t from-black to-transparent opacity-50 pointer-events-none lg:hidden" />
        {/* Gradient overlay for desktop screens, only over 3/5 of image */}
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:left-0 lg:w-3/5 lg:bg-linear-to-r lg:from-black lg:to-transparent lg:opacity-50 lg:pointer-events-none" />
      </div>

      <div className="lg:absolute lg:inset-y-0 lg:left-8 xl:left-16 w-xs sm:w-sm md:w-3xl lg:w-lg lg:top-16 xl:w-2xl flex flex-col justify-center text-start gap-y-3 md:gap-y-6 mx-4 lg:mx-0 mt-6 lg:mt-0">
        {banner?.title && (
          <p
            className={`w-full font-axi-bold text-4xl md:text-6xl ${banner.hasDarkText === true ? 'text-black' : 'lg:text-white'}`}
          >
            {banner.title}
          </p>
        )}
        {banner?.content && (
          <p
            className={`w-full font-axi-bold lg:font-axi-book text-2xl md:text-3xl ${banner.hasDarkText === true ? 'text-black' : 'lg:text-white'}`}
          >
            {banner.content}
          </p>
        )}

        {banner?.buttons[0]?.title && (
          <LocalizedLink
            to={banner.buttons[0]?.url || window.location.href}
            className={`flex items-center justify-center whitespace-nowrap font-axi-book text-sm rounded-4xl py-2.5 px-7 hover:shadow-2xl w-fit transition-all duration-100 ${
              banner.hasDarkText === true
                ? 'text-white bg-black hover:bg-rgrey-darker'
                : 'text-white bg-black hover:bg-rgrey-darker lg:text-black lg:bg-white hover:lg:bg-rgrey-light'
            }`}
          >
            {banner.buttons[0]?.title || 'Vaata tooteid'}
          </LocalizedLink>
        )}
      </div>
    </div>
  );
}
